const footer = {
    setHandlers() {
        $("footer #btn-clearSubscribe").click(function () {
            $("#npt-subscriberEmail").val("");
        });
    },
    start() {
        this.setHandlers();
    },
};
$(() => {
    footer.start();
});
